import { Card as AntdCard } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(AntdCard)`
  border-radius: 0 20px;
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);

  &:not(.ant-card-bordered) {
    box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.1);
  }
`;
